import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DocumentoSalidaService } from '../../services/documento-salida.service';
import { DocumentoSalida } from '../../model/documento-salida';
import { DocumentoDetalleSalidaService } from '../../services/documento-detalle-salida.service';
import { DocumentoDetalleSalida } from '../../model/documento-detalle-salida';


@Component({
  selector: 'app-documento-salida-detalle-list',
  templateUrl: './documento-salida-detalle-list.component.html',
  styleUrls: ['./documento-salida-detalle-list.component.css']
})
export class DocumentoSalidaDetalleListComponent implements OnInit {

  public modoEdicion: boolean = false;

  @Input() documento: DocumentoSalida;
  @Input() detalles: DocumentoDetalleSalida[];

  //public detalles: DocumentoDetalleSalida[];
  public detalle: DocumentoDetalleSalida;

  public detalleSeleccionado: DocumentoDetalleSalida;

  constructor(
    private _documentoDetalleSalidaService: DocumentoDetalleSalidaService,
  ) { }

  ngOnInit() {
    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }
  }

  cargarDetalle() {
    if (this.documento.codigoConsorcio && this.documento.codigoDocumento) {
      this._documentoDetalleSalidaService.getDetalle(this.documento)
        .subscribe(
        data => {
          this.detalles = data;
        },
        err => {
          console.log(err);
        });
    }
  }

  agregarRegistro() {
    if (this.documento === null) {
      return;
    }
    this.detalleSeleccionado = new DocumentoDetalleSalida();
    this.modoEdicion = true;
  }


  regresar() {
    this.modoEdicion = false;
    this.cargarDetalle();
  }


  editarRegistro(detalle: DocumentoDetalleSalida) {
    this.detalleSeleccionado = detalle;
    this.modoEdicion = true;
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-salida-detalle-list/documento-salida-detalle-list.component.ts